/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-29 15:44:42
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-08-02 13:14:03
 * @FilePath: /wemeet-web-activity/src/components/Layout/CustomFooter/data.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const SPONSOR_PROTOCOL_LINK = '/activity-sponsor-service-agreement.html';

export const PARTICIPANTS_PROTOCOL_LINK = '/activity-participants-service-agreement.html';

export const NO_PROTOCOL_PATH = [
  '/personal',
  'basic',
  'registration/register',
  '/service-order',
  '/income/withdraw',
  '/income/order-management',
  'registration/access',
];
